// ============================================================
// Braval - Authenticated fetch helper
// Acquires an idToken from MSAL and attaches it to every
// API request as Authorization: Bearer <token>
// ============================================================

import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from './App';
import { apiRequest } from './authConfig';

export async function apiFetch(url, options = {}) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) throw new Error('Not authenticated');

    let tokenResponse;
    try {
        tokenResponse = await msalInstance.acquireTokenSilent({
            ...apiRequest,
            account: accounts[0],
        });
    } catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
            await msalInstance.acquireTokenRedirect({ ...apiRequest, account: accounts[0] });
            return; // redirect will reload the page
        }
        throw err;
    }

    const accessToken = tokenResponse?.accessToken;
    if (!accessToken) {
        console.error('apiFetch: acquireTokenSilent returned no accessToken — forcing re-login');
        await msalInstance.acquireTokenRedirect({ ...apiRequest, account: accounts[0] });
        return;
    }

    return fetch(url, {
        ...options,
        headers: {
            ...options.headers,
            'Authorization': `Bearer ${accessToken}`,
        },
    });
}
